import { productService } from "../services/products";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { productPricesService } from "../services/product_prices";
import { companyService } from "../services/companies";
import { clearAllTables } from "../utils/ui_utils";
import { hideMenu } from "../shared.js";

export class ProductController {
  constructor() {
    this.type = "product";
    this.productNav = document.querySelector(".product_nav");
    this.productTableWindow = document.querySelector(".product_table_window");
    this.updateWindow = document.querySelector(".update-product-window");
    this.form = document.querySelector(".upload-product");
    this.btnModal = document.querySelector(".table_modal-product");
    this.table = null; // Tabulator instance
  }

  async init(currBtn, currAcc) {
    this.updateUI(currBtn);
    this.currentUser = currAcc;

    if (currAcc.status === "admin") {
      await this.initAdminView(currAcc);
    } else if (currAcc.status === "std") {
      await this.initStandardView();
    }
  }

  async initAdminView(currAcc) {
    // Get products from Supabase
    const result = await productService.listProducts();
    if (!result.success) {
      console.error("Failed to load products:", result.error);
      return;
    }

    // Setup the data table
    this.setupDataTable(result.data, true);
  }

  async initStandardView() {
    const result = await productService.listProducts();
    if (!result.success) {
      console.error("Failed to load products:", result.error);
      return;
    }

    // Setup the data table (read-only)
    this.setupDataTable(result.data, false);
  }

  setupDataTable(data, isAdmin = false) {
    console.log("Setting up data table with data:", data);

    // Clear existing table and add Bootstrap container
    this.productTableWindow.innerHTML = `
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-12">
            <div class="card border-0 shadow-lg">
              <div class="card-header" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; padding: 1.5rem;">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="bg-white rounded-circle p-2 me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                      <img src="/icons/menu-product1.jpg" alt="Product Icon" style="width: 35px; height: 35px; border-radius: 15px; object-fit: cover;">
                    </div>
                    <div>
                      <h5 class="card-title mb-0 text-white fw-bold">Gestione Prodotti</h5>
                      <small class="text-white opacity-75"></small>
                    </div>
                  </div>
                  ${
                    isAdmin
                      ? `
                    <button class="btn btn-light add-product-btn shadow-sm" style="padding: 0.75rem 1.5rem; border-radius: 10px; font-weight: 500;">
                      <i class="bi bi-plus-circle me-2" style="color: #59a370;"></i>
                      <span style="color: #59a370;">Aggiungi Prodotto</span>
                    </button>
                  `
                      : ""
                  }
                </div>
              </div>
              <div class="card-body p-0" style="border-radius: 0 0 15px 15px; overflow: hidden;">
                <div id="products-table" style="width: 100%; min-height: 400px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add event listener for the new add button
    if (isAdmin) {
      const addBtn = this.productTableWindow.querySelector(".add-product-btn");
      if (addBtn) {
        addBtn.addEventListener("click", () => this.handleAddProduct());
      }
    }

    // Add custom styles first
    this.addCustomStyles();

    // Define columns based on user role
    const columns = [
      {
        title: "Prodotto",
        field: "product_name",
        sorter: "string",
        width: 200,
        headerFilter: "input",
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-info text-white mb-1">N</span><span>Azoto</span></div>',
        field: "nitrogen_n",
        sorter: "number",
        width: 110,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-warning text-dark mb-1">P2O5</span><span>Fosforo</span></div>',
        field: "phosphorus_p2o5",
        sorter: "number",
        width: 115,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-success text-white mb-1">K2O</span><span>Potassio</span></div>',
        field: "potassium_k2o",
        sorter: "number",
        width: 125,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-primary text-white mb-1">CaO</span><span>Calcio</span></div>',
        field: "calcium_cao",
        sorter: "number",
        width: 110,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-secondary text-white mb-1">MgO</span><span>Magnesio</span></div>',
        field: "magnesium_mgo",
        sorter: "number",
        width: 125,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span class="badge bg-dark text-white mb-1">SO3</span><span>Zolfo</span></div>',
        field: "sulfur_so3",
        sorter: "number",
        width: 110,
        formatter: (cell) =>
          `<strong>${parseFloat(cell.getValue()).toFixed(2)}</strong>`,
      },
    ];

    // Add action buttons for admin users
    if (isAdmin) {
      columns.push({
        title: "€/kg",
        field: "price_list",
        width: 90,
        sorter: false,
        headerSort: false,
        formatter: () => {
          return `
            <button class="btn btn-outline-info btn-sm btn-price-list" title="Listino Prezzi">
              <i class="bi bi-currency-euro" style="pointer-events: none;"></i>
            </button>
          `;
        },
        cellClick: (e, cell) => {
          e.stopPropagation();
          const target = e.target.closest("button");
          if (!target) return;

          if (target.classList.contains("btn-price-list")) {
            this.handlePriceList(cell.getRow().getData());
          }
        },
      });

      columns.push({
        title: "Azioni",
        field: "actions",
        width: 95,
        sorter: false,
        headerSort: false,
        formatter: () => {
          return `
            <div class="btn-group" role="group">
              <button class="btn btn-outline-primary btn-sm btn-edit" title="Modifica">
                <i class="bi bi-pencil" style="pointer-events: none;"></i>
              </button>
              <button class="btn btn-outline-danger btn-sm btn-delete" title="Elimina">
                <i class="bi bi-trash" style="pointer-events: none;"></i>
              </button>
            </div>
          `;
        },
        cellClick: (e, cell) => {
          e.stopPropagation();
          const target = e.target.closest("button");
          if (!target) return;

          const rowData = cell.getRow().getData();

          if (target.classList.contains("btn-edit")) {
            this.handleUpdateProduct(rowData);
          } else if (target.classList.contains("btn-delete")) {
            this.handleDeleteProduct(rowData);
          }
        },
      });
    }

    // Initialize Tabulator
    setTimeout(() => {
      try {
        this.table = new Tabulator("#products-table", {
          data: data,
          columns: columns,
          layout: "fitColumns",
          responsiveLayout: "hide",
          pagination: "local",
          paginationSize: 15,
          paginationSizeSelector: [10, 15, 25, 50],
          movableColumns: true,
          resizableRows: true,
          tooltips: true,
          tooltipsHeader: true,
          initialSort: [{ column: "product_id", dir: "asc" }],
          placeholder: "Nessun prodotto trovato",
          langs: {
            it: {
              pagination: {
                page_size: "Righe per pagina",
                page_title: "Mostra pagina",
                first: "Prima",
                first_title: "Prima pagina",
                last: "Ultima",
                last_title: "Ultima pagina",
                prev: "Precedente",
                prev_title: "Pagina precedente",
                next: "Successiva",
                next_title: "Pagina successiva",
                all: "Tutte",
                counter: {
                  showing: "Mostrando",
                  of: "di",
                  rows: "righe",
                },
              },
              headerFilters: {
                default: "Filtra colonna...",
                columns: {
                  product_id: "Filtra per ID...",
                  product_name: "Filtra per prodotto...",
                },
              },
            },
          },
          locale: "it",
          columnDefaults: {
            tooltip: true,
          },
        });

        console.log("Tabulator created successfully:", this.table);
      } catch (error) {
        console.error("Error creating Tabulator:", error);
        // Fallback to simple table
        this.createFallbackTable(data, columns);
      }
    }, 100);
  }

  addCustomStyles() {
    if (document.getElementById("product-table-styles")) return;

    const style = document.createElement("style");
    style.id = "product-table-styles";
    style.textContent = `
      /* Tabulator base styling */
      .tabulator {
        border: none !important;
        border-radius: 0 !important;
        font-family: 'Poppins', sans-serif !important;
        font-size: 14px !important;
        background-color: white !important;
        overflow: hidden !important;
      }
      
      /* Header styling */
      .tabulator .tabulator-header {
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
        border-bottom: 2px solid #59a370 !important;
      }
      
      .tabulator .tabulator-header .tabulator-col {
        background: transparent !important;
        border-right: 1px solid #e5e7eb !important;
        padding: 15px 12px !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-col-content {
        padding: 0 !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-col-title {
        font-weight: 600 !important;
        color: #59a370 !important;
        font-size: 13px !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
      }
      
      .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover {
        background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%) !important;
      }
      
      .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover .tabulator-col-title {
        color: white !important;
      }
      
      /* Row styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row {
        border-bottom: 1px solid #f1f5f9 !important;
        min-height: 50px !important;
        transition: all 0.2s ease !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row:hover {
        background: linear-gradient(135deg, #f0f9f4 0%, #ecfdf5 100%) !important;
        box-shadow: 0 2px 4px rgba(89, 163, 112, 0.1) !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-row-even {
        background-color: #ffffff !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-row-odd {
        background-color: #fafbfc !important;
      }
      
      /* Cell styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell {
        border-right: 1px solid #f3f4f6 !important;
        padding: 12px !important;
        vertical-align: middle !important;
        font-weight: 500 !important;
      }
      
      /* Number cells styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell[tabulator-field^="nitrogen"],
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell[tabulator-field^="phosphorus"],
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell[tabulator-field^="potassium"],
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell[tabulator-field^="calcium"],
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell[tabulator-field^="magnesium"],
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell[tabulator-field^="sulfur"] {
        text-align: center !important;
        font-family: 'Monaco', 'Consolas', monospace !important;
        background-color: #f8fafc !important;
        color: #59a370 !important;
        font-weight: 600 !important;
      }
      
      /* Filter styling */
      .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input {
        border: 2px solid #e5e7eb !important;
        border-radius: 8px !important;
        padding: 6px 12px !important;
        font-size: 12px !important;
        width: 100% !important;
        box-sizing: border-box !important;
        transition: all 0.3s ease !important;
        font-family: 'Poppins', sans-serif !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input:focus {
        outline: none !important;
        border-color: #59a370 !important;
        box-shadow: 0 0 0 3px rgba(89, 163, 112, 0.1) !important;
        background-color: #f8fafc !important;
      }
      
      /* Pagination styling */
      .tabulator .tabulator-footer {
        border-top: 2px solid #e5e7eb !important;
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
        padding: 15px 20px !important;
        border-radius: 0 0 15px 15px !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page {
        background-color: white !important;
        border: 2px solid #e5e7eb !important;
        color: #59a370 !important;
        margin: 0 3px !important;
        padding: 8px 12px !important;
        border-radius: 8px !important;
        font-weight: 500 !important;
        transition: all 0.2s ease !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page.active {
        background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%) !important;
        color: white !important;
        border-color: #59a370 !important;
        box-shadow: 0 2px 4px rgba(89, 163, 112, 0.2) !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page:hover:not(.active) {
        background-color: #f0f9f4 !important;
        border-color: #59a370 !important;
        transform: translateY(-1px) !important;
      }
      
      /* Bootstrap button group styling for actions */
      .btn-group .btn {
        margin: 0 !important;
        border-radius: 6px !important;
        transition: all 0.2s ease !important;
      }
      
      .btn-group .btn-outline-primary {
        border-color: #59a370 !important;
        color: #59a370 !important;
      }
      
      .btn-group .btn-outline-primary:hover {
        background-color: #59a370 !important;
        border-color: #59a370 !important;
        transform: translateY(-1px) !important;
      }
      
      .btn-group .btn-outline-danger:hover {
        transform: translateY(-1px) !important;
      }
      
      /* Responsive adjustments */
      @media (max-width: 768px) {
        .tabulator {
          font-size: 12px !important;
        }
        
        .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell {
          padding: 8px 6px !important;
        }
        
        .btn-group .btn {
          padding: 4px 8px !important;
          font-size: 12px !important;
        }
        
        .tabulator .tabulator-header .tabulator-col {
          padding: 10px 8px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  handleAddProduct() {
    console.log("Adding new product");

    // Add Bootstrap modal classes to the update window
    this.updateWindow.classList.remove("hidden");
    this.updateWindow.classList.add("modal", "fade", "show");
    this.updateWindow.style.display = "block";
    this.updateWindow.style.backgroundColor = "rgba(0,0,0,0.5)";

    // Update the modal content with Bootstrap structure
    this.form.innerHTML = `
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body p-5">
            ${this.createBootstrapFormMarkup()}
          </div>
        </div>
      </div>
    `;

    // Handle form submission
    const uploadBtn = this.form.querySelector(".uploadProduct__btn");
    const cancelBtn = this.form.querySelector('[data-bs-dismiss="modal"]');

    uploadBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await this.submitNewProduct();
    });

    cancelBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  async handleUpdateProduct(productData) {
    console.log("Updating product:", productData);

    // Add Bootstrap modal classes to the update window
    this.updateWindow.classList.remove("hidden");
    this.updateWindow.classList.add("modal", "fade", "show");
    this.updateWindow.style.display = "block";
    this.updateWindow.style.backgroundColor = "rgba(0,0,0,0.5)";

    // Update the modal content with Bootstrap structure
    this.form.innerHTML = `
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body p-5">
            ${this.createBootstrapFormMarkup(true, productData)}
          </div>
        </div>
      </div>
    `;

    // Handle form submission
    const uploadBtn = this.form.querySelector(".uploadProduct__btn");
    const cancelBtn = this.form.querySelector('[data-bs-dismiss="modal"]');

    uploadBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await this.submitUpdateProduct(productData.id);
    });

    cancelBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  async handleDeleteProduct(productData) {
    console.log("Deleting product:", productData);

    // Create Bootstrap confirmation modal
    const confirmationHtml = `
      <div class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);" id="deleteConfirmModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title">
                <i class="bi bi-exclamation-triangle me-2"></i>Conferma Eliminazione
              </h5>
            </div>
            <div class="modal-body">
              <p class="mb-3">Sei sicuro di voler eliminare il prodotto:</p>
              <div class="alert alert-warning">
                <strong><img src="/icons/menu-product1.jpg" alt="Product Icon" style="width: 20px; height: 20px; border-radius: 10px; object-fit: cover; margin-right: 8px; vertical-align: middle;">${productData.product_name}</strong>
              </div>
              <p class="text-muted small">Questa azione non può essere annullata.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="cancelDelete">
                <i class="bi bi-x-circle me-1"></i>Annulla
              </button>
              <button type="button" class="btn btn-danger" id="confirmDelete">
                <i class="bi bi-trash me-1"></i>Elimina
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add modal to body
    const modalContainer = document.createElement("div");
    modalContainer.innerHTML = confirmationHtml;
    document.body.appendChild(modalContainer);

    const modal = modalContainer.querySelector("#deleteConfirmModal");
    const confirmBtn = modal.querySelector("#confirmDelete");
    const cancelBtn = modal.querySelector("#cancelDelete");

    // Handle confirmation
    confirmBtn.addEventListener("click", async () => {
      const result = await productService.deleteProduct(productData.id);
      if (result.success) {
        await this.refreshTable();
        this.showNotification("Prodotto eliminato con successo", "success");
      } else {
        console.error("Failed to delete product:", result.error);
        this.showNotification("Errore nell'eliminazione del prodotto", "error");
      }
      document.body.removeChild(modalContainer);
    });

    // Handle cancellation
    cancelBtn.addEventListener("click", () => {
      document.body.removeChild(modalContainer);
    });
  }

  async submitNewProduct() {
    const productData = this.getProductDataFromForm();

    if (!this.validateProductData(productData)) {
      this.showNotification("Compila tutti i campi obbligatori", "error");
      return;
    }

    // Check for duplicate product_name
    const checkResult = await productService.existsProductByName(
      productData.product_name
    );
    if (!checkResult.success) {
      this.showNotification("Errore nel controllo del nome prodotto.", "error");
      return;
    }
    if (checkResult.exists) {
      this.showNotification("Esiste già un prodotto con questo nome.", "error");
      return;
    }

    console.log("Creating product:", productData);
    const result = await productService.createProduct(productData);

    if (result.success) {
      this.closeModal();
      await this.refreshTable();
      this.showNotification("Prodotto creato con successo", "success");
    } else {
      console.error("Failed to create product:", result.error);
      this.showNotification("Errore nella creazione del prodotto", "error");
    }
  }

  async submitUpdateProduct(productId) {
    const productData = this.getProductDataFromForm();

    if (!this.validateProductData(productData)) {
      this.showNotification("Compila tutti i campi obbligatori", "error");
      return;
    }

    console.log("Updating product:", productId, productData);
    const result = await productService.updateProduct(productId, productData);

    if (result.success) {
      this.closeModal();
      await this.refreshTable();
      this.showNotification("Prodotto aggiornato con successo", "success");
    } else {
      console.error("Failed to update product:", result.error);
      this.showNotification("Errore nell'aggiornamento del prodotto", "error");
    }
  }

  getProductDataFromForm() {
    return {
      product_name: this.form
        .querySelector('[name="product_name"]')
        .value.trim(),
      nitrogen_n:
        Number(this.form.querySelector('[name="nitrogen_n"]').value) || 0,
      phosphorus_p2o5:
        Number(this.form.querySelector('[name="phosphorus_p2o5"]').value) || 0,
      potassium_k2o:
        Number(this.form.querySelector('[name="potassium_k2o"]').value) || 0,
      calcium_cao:
        Number(this.form.querySelector('[name="calcium_cao"]').value) || 0,
      magnesium_mgo:
        Number(this.form.querySelector('[name="magnesium_mgo"]').value) || 0,
      sulfur_so3:
        Number(this.form.querySelector('[name="sulfur_so3"]').value) || 0,
    };
  }

  validateProductData(productData) {
    return productData.product_name && productData.product_name.length > 0;
  }

  closeModal() {
    this.updateWindow.classList.add("hidden");
    this.updateWindow.classList.remove("modal", "fade", "show");
    this.updateWindow.style.display = "none";
    this.updateWindow.style.backgroundColor = "";
    this.form.innerHTML = "";
  }

  async refreshTable() {
    if (!this.table) return;

    const result = await productService.listProducts();
    if (result.success) {
      this.table.setData(result.data);
    }
  }

  showNotification(message, type = "info") {
    // Create Bootstrap toast notification
    const toastId = `toast-${Date.now()}`;
    const iconClass =
      type === "success"
        ? "bi-check-circle-fill"
        : type === "error"
        ? "bi-exclamation-triangle-fill"
        : "bi-info-circle-fill";

    // Use our app's green theme colors
    const bgClass =
      type === "success"
        ? "text-white"
        : type === "error"
        ? "text-white"
        : "text-white";

    const bgStyle =
      type === "success"
        ? "background: linear-gradient(135deg, #059669 0%, #047857 100%);"
        : type === "error"
        ? "background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);"
        : "background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%);";

    const toastHtml = `
      <div class="toast align-items-center ${bgClass} border-0 shadow-lg" role="alert" aria-live="assertive" aria-atomic="true" id="${toastId}" style="${bgStyle} border-radius: 12px;">
        <div class="d-flex">
          <div class="toast-body py-3 px-4" style="font-weight: 500; font-size: 14px;">
            <i class="${iconClass} me-2" style="font-size: 16px;"></i>${message}
          </div>
          <button type="button" class="btn-close btn-close-white me-3 my-auto" data-bs-dismiss="toast" aria-label="Close" style="filter: brightness(0) invert(1);"></button>
        </div>
      </div>
    `;

    // Create or get toast container
    let toastContainer = document.querySelector(
      ".toast-container.fertify-notifications"
    );
    if (!toastContainer) {
      toastContainer = document.createElement("div");
      toastContainer.className =
        "toast-container fertify-notifications position-fixed top-0 end-0 p-3";
      toastContainer.style.zIndex = "9999";
      toastContainer.style.marginTop = "80px"; // Account for navbar height
      document.body.appendChild(toastContainer);
    }

    // Add toast to container
    const toastElement = document.createElement("div");
    toastElement.innerHTML = toastHtml;
    toastContainer.appendChild(toastElement.firstElementChild);

    // Initialize and show Bootstrap toast
    const toast = new bootstrap.Toast(document.getElementById(toastId), {
      autohide: true,
      delay: 5000,
    });

    toast.show();

    // Add custom animation styles
    const toastEl = document.getElementById(toastId);
    toastEl.style.transform = "translateX(100%)";
    toastEl.style.transition = "transform 0.3s ease-out";

    // Animate in
    setTimeout(() => {
      toastEl.style.transform = "translateX(0)";
    }, 10);

    // Remove toast element after it's hidden
    toastEl.addEventListener("hidden.bs.toast", () => {
      toastEl.style.transform = "translateX(100%)";
      setTimeout(() => {
        if (toastEl && toastEl.parentNode) {
          toastEl.remove();
        }
      }, 300);
    });
  }

  updateUI(currBtn) {
    // Clear active states and set current button as active
    document.querySelectorAll(".menu__btn").forEach((btn) => {
      btn.classList.remove("menu__btn--active");
    });
    currBtn.classList.add("menu__btn--active");

    hideMenu();
    // Clear all table windows
    clearAllTables(false);
  }

  // Create Bootstrap-styled form markup
  createBootstrapFormMarkup(isEdit = false, productData = null) {
    const title = isEdit ? "Modifica Prodotto" : "Aggiungi Prodotto";
    const buttonText = isEdit ? "Aggiorna" : "Salva";

    return `
      <div class="modal-header border-bottom-0 pb-3 mb-4" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); margin: -2rem -2rem 2rem -2rem; padding: 2rem; border-radius: 15px 15px 0 0;">
        <div class="d-flex align-items-center text-white">
          <div class="bg-white rounded-circle p-2 me-3" style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center;">
            <img src="/icons/menu-product1.jpg" alt="Product Icon" style="width: 40px; height: 40px; border-radius: 20px; object-fit: cover;">
          </div>
          <div>
            <h4 class="modal-title mb-0 fw-bold">${title}</h4>
            <small class="opacity-75"></small>
          </div>
        </div>
      </div>
      
      <form class="needs-validation" novalidate>
        <div class="row g-4">
          <!-- Product Name -->
          <div class="col-12 mb-3">
            <label for="product_name" class="form-label fw-semibold fs-5" style="color: #59a370;">
              <img src="/icons/menu-product1.jpg" alt="Product Icon" style="width: 20px; height: 20px; border-radius: 10px; object-fit: cover; margin-right: 8px; vertical-align: middle;">Nome Prodotto
            </label>
            <input 
              type="text" 
              class="form-control form-control-lg" 
              id="product_name" 
              name="product_name" 
              placeholder="Inserisci il nome del prodotto"
              value="${productData?.product_name || ""}"
              style="border: 2px solid #e5e7eb; border-radius: 10px; padding: 1rem; font-size: 1.1rem;"
              required
            >
            <div class="invalid-feedback">
              Il nome del prodotto è obbligatorio.
            </div>
          </div>

          <!-- Nutrient Values Section -->
          <div class="col-12">
            <div class="bg-light p-3 rounded-3 mb-3" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;">
              <h6 class="mb-0 fw-bold" style="color: #59a370;">
                <i class="bi bi-graph-up me-2"></i>Valori Nutrizionali
              </h6>
              <small class="text-muted">Inserisci i valori per ogni nutriente</small>
            </div>
          </div>

          <!-- Nutrient Values Row 1 -->
          <div class="col-lg-6">
            <label for="nitrogen_n" class="form-label fw-semibold">
              <span class="badge bg-info me-2">N</span>Azoto
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="nitrogen_n" 
                name="nitrogen_n" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${productData?.nitrogen_n || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <div class="col-lg-6">
            <label for="phosphorus_p2o5" class="form-label fw-semibold">
              <span class="badge bg-warning text-dark me-2">P2O5</span>Fosforo
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="phosphorus_p2o5" 
                name="phosphorus_p2o5" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${productData?.phosphorus_p2o5 || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <!-- Nutrient Values Row 2 -->
          <div class="col-lg-6">
            <label for="potassium_k2o" class="form-label fw-semibold">
              <span class="badge bg-success text-white me-2">K2O</span>Potassio
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="potassium_k2o" 
                name="potassium_k2o" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${productData?.potassium_k2o || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <div class="col-lg-6">
            <label for="calcium_cao" class="form-label fw-semibold">
              <span class="badge bg-primary text-white me-2">CaO</span>Calcio
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="calcium_cao" 
                name="calcium_cao" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${productData?.calcium_cao || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <!-- Nutrient Values Row 3 -->
          <div class="col-lg-6">
            <label for="magnesium_mgo" class="form-label fw-semibold">
              <span class="badge bg-secondary text-white me-2">MgO</span>Magnesio
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="magnesium_mgo" 
                name="magnesium_mgo" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${productData?.magnesium_mgo || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>

          <div class="col-lg-6">
            <label for="sulfur_so3" class="form-label fw-semibold">
              <span class="badge bg-dark text-white me-2">SO3</span>Zolfo
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="sulfur_so3" 
                name="sulfur_so3" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${productData?.sulfur_so3 || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
                required
              >
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="modal-footer border-top pt-4 mt-5 d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-outline-secondary btn-lg px-4" data-bs-dismiss="modal" style="border-radius: 10px;">
            <i class="bi bi-x-circle me-2"></i>Annulla
          </button>
          <button type="submit" class="btn btn-lg px-5 uploadProduct__btn" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; color: white; border-radius: 10px; font-weight: 500;">
            <i class="bi bi-check-circle me-2"></i>${buttonText}
          </button>
        </div>
      </form>
    `;
  }

  async handlePriceList(productData) {
    console.log("Opening price list for product:", productData);

    // Fetch companies for dropdown
    const companiesResult = await companyService.listCompanies();
    if (!companiesResult.success) {
      this.showNotification("Errore nel caricamento delle aziende", "error");
      return;
    }

    // Fetch existing prices
    const pricesResult = await productPricesService.listPricesByProduct(
      productData.id
    );
    if (!pricesResult.success) {
      this.showNotification("Errore nel caricamento dei prezzi", "error");
      return;
    }

    // Filter out companies that already have prices
    const existingCompanyIds = new Set(
      pricesResult.data.map((price) => price.companies?.id)
    );
    const availableCompanies = companiesResult.data.filter(
      (company) => !existingCompanyIds.has(company.id.toString())
    );

    console.log("Existing company IDs:", existingCompanyIds);
    console.log("Available companies:", availableCompanies);

    // Create modal content
    const modalContent = `
      <div class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);" id="priceListModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%);">
              <h5 class="modal-title text-white">
                <i class="bi bi-currency-euro me-2"></i>
                Listino prodotto: ${productData.product_name}
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-4">
              <!-- Add Price CTA -->
              <div class="d-flex justify-content-end mb-4">
                <button class="btn btn-success shadow-sm" id="showAddPriceForm" ${
                  availableCompanies.length === 0 ? "disabled" : ""
                }>
                  <i class="bi bi-plus-circle me-2" style="pointer-events: none;"></i>
                  Aggiungi Prezzo
                </button>
              </div>

              <!-- Add Price Form (initially hidden) -->
              <div id="addPriceForm" class="mb-4" style="display: none;">
                <div class="card shadow-sm border-0" style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);">
                  <div class="card-body p-4">
                    <div class="d-flex justify-content-between align-items-center mb-4">
                      <h6 class="card-title mb-0 fw-bold" style="color: #59a370;">
                        <i class="bi bi-plus-circle me-2"></i>
                        Nuovo Prezzo
                      </h6>
                      <button type="button" class="btn-close" id="closeAddPriceForm"></button>
                    </div>
                    
                    <div class="row g-4">
                      <div class="col-md-7">
                        <label for="newCompanySelect" class="form-label fw-semibold mb-2">Azienda</label>
                        <select class="form-select form-select-lg shadow-sm" id="newCompanySelect" 
                          ${availableCompanies.length === 0 ? "disabled" : ""} 
                          style="border: 2px solid #e2e8f0; border-radius: 10px;">
                          <option value="">--Seleziona azienda--</option>
                          ${availableCompanies
                            .map(
                              (company) => `
                            <option value="${company.id}">${company.company_name}</option>
                          `
                            )
                            .join("")}
                        </select>
                        ${
                          availableCompanies.length === 0
                            ? '<div class="mt-2"><small class="text-muted"><i class="bi bi-info-circle me-1"></i>Tutte le aziende hanno già un prezzo impostato</small></div>'
                            : ""
                        }
                      </div>
                      <div class="col-md-5">
                        <label for="newPriceInput" class="form-label fw-semibold mb-2">Prezzo per kg</label>
                        <div class="input-group input-group-lg shadow-sm">
                          <input type="number" 
                            class="form-control" 
                            id="newPriceInput" 
                            placeholder="0.00" 
                            step="0.01" 
                            min="0"
                            style="border: 2px solid #e2e8f0; border-right: none; border-radius: 10px 0 0 10px;">
                          <span class="input-group-text" style="border: 2px solid #e2e8f0; border-left: none; background: white; border-radius: 0 10px 10px 0;">€/kg</span>
                        </div>
                      </div>
                      <div class="col-12 d-flex justify-content-end mt-4">
                        <button class="btn btn-success btn-lg px-4" id="addPriceBtn" ${
                          availableCompanies.length === 0 ? "disabled" : ""
                        }>
                          <i class="bi bi-check-circle me-2" style="pointer-events: none;"></i>
                          Salva Prezzo
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Prices Table -->
              <div class="table-responsive">
                <table class="table" style="font-family: 'Poppins', sans-serif; font-size: 14px; border: none; border-radius: 0; background-color: white; overflow: hidden;">
                  <thead style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); border-bottom: 2px solid #59a370;">
                    <tr>
                      <th style="padding: 15px 12px; font-weight: 600; color: #59a370; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px; border-right: 1px solid #e5e7eb;">Azienda</th>
                      <th style="padding: 15px 12px; font-weight: 600; color: #59a370; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px; border-right: 1px solid #e5e7eb; width: 200px;">Prezzo (€/kg)</th>
                      <th style="padding: 15px 12px; font-weight: 600; color: #59a370; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px; width: 100px;">Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${
                      pricesResult.data.length === 0
                        ? `
                      <tr>
                        <td colspan="3" class="text-center text-muted py-4" style="border-bottom: 1px solid #f1f5f9;">
                          <i class="bi bi-info-circle me-2"></i>
                          Nessun prezzo impostato
                        </td>
                      </tr>
                    `
                        : pricesResult.data
                            .map(
                              (price, index) => `
                      <tr data-price-id="${
                        price.id
                      }" style="border-bottom: 1px solid #f1f5f9; min-height: 50px; transition: all 0.2s ease; background-color: ${
                                index % 2 === 0 ? "#ffffff" : "#fafbfc"
                              };">
                        <td class="align-middle" style="padding: 12px; vertical-align: middle; font-weight: 500; border-right: 1px solid #f3f4f6;">${
                          price.companies.company_name
                        }</td>
                        <td style="padding: 12px; vertical-align: middle; font-weight: 500; border-right: 1px solid #f3f4f6;">
                          <div class="d-flex gap-2">
                            <div class="input-group input-group-sm shadow-sm">
                              <input type="number" 
                                class="form-control price-input" 
                                value="${price.price_per_kg}" 
                                step="0.01" 
                                min="0"
                                data-original-value="${price.price_per_kg}"
                                style="border: 2px solid #e2e8f0; border-right: none; border-radius: 8px 0 0 8px; font-family: 'Monaco', 'Consolas', monospace; background-color: #f8fafc; color: #59a370; font-weight: 600;">
                              <span class="input-group-text" style="border: 2px solid #e2e8f0; border-left: none; background: white; border-radius: 0 8px 8px 0;">€/kg</span>
                            </div>
                            <button class="btn btn-success btn-sm update-price" style="display: none; border-radius: 6px; transition: all 0.2s ease;">
                              <i class="bi bi-check-lg" style="pointer-events: none;"></i>
                            </button>
                          </div>
                        </td>
                        <td class="align-middle" style="padding: 12px; vertical-align: middle; font-weight: 500;">
                          <button class="btn btn-outline-danger btn-sm delete-price" style="border-radius: 6px; transition: all 0.2s ease;">
                            <i class="bi bi-trash" style="pointer-events: none;"></i>
                          </button>
                        </td>
                      </tr>
                    `
                            )
                            .join("")
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add modal to body
    const modalContainer = document.createElement("div");
    modalContainer.innerHTML = modalContent;
    document.body.appendChild(modalContainer);

    const modal = modalContainer.querySelector("#priceListModal");
    const closeBtn = modal.querySelector('[data-bs-dismiss="modal"]');
    const showAddPriceFormBtn = modal.querySelector("#showAddPriceForm");
    const addPriceForm = modal.querySelector("#addPriceForm");
    const closeAddPriceFormBtn = modal.querySelector("#closeAddPriceForm");
    const addPriceBtn = modal.querySelector("#addPriceBtn");
    const priceInputs = modal.querySelectorAll(".price-input");
    const deletePriceBtns = modal.querySelectorAll(".delete-price");

    // Toggle add price form
    showAddPriceFormBtn?.addEventListener("click", () => {
      addPriceForm.style.display = "block";
      showAddPriceFormBtn.style.display = "none";
    });

    closeAddPriceFormBtn?.addEventListener("click", () => {
      addPriceForm.style.display = "none";
      showAddPriceFormBtn.style.display = "block";
    });

    // Handle price updates
    priceInputs.forEach((input) => {
      const row = input.closest("tr");
      const updateBtn = row.querySelector(".update-price");
      const originalValue = parseFloat(input.dataset.originalValue);

      // Store original value in a variable to handle comparison
      let currentValue = originalValue;

      input.addEventListener("input", (e) => {
        const newValue = parseFloat(e.target.value);

        // Only show button if value is valid and different from current
        if (!isNaN(newValue) && newValue !== currentValue) {
          updateBtn.style.display = "inline-flex";
        } else {
          updateBtn.style.display = "none";
        }
      });

      // Handle the update button click
      updateBtn.addEventListener("click", async () => {
        const priceId = row.dataset.priceId;
        const newPrice = parseFloat(input.value);

        if (!isNaN(newPrice)) {
          const result = await productPricesService.updatePrice(
            priceId,
            newPrice
          );
          if (result.success) {
            // Update the current value and original value
            currentValue = newPrice;
            input.dataset.originalValue = newPrice.toString();
            updateBtn.style.display = "none";
            this.showNotification("Prezzo aggiornato con successo", "success");
          } else {
            // Revert to original value on error
            input.value = currentValue;
            updateBtn.style.display = "none";
            this.showNotification(
              "Errore nell'aggiornamento del prezzo",
              "error"
            );
          }
        }
      });

      // Add blur handler to validate input
      input.addEventListener("blur", (e) => {
        const value = parseFloat(e.target.value);
        if (isNaN(value) || value < 0) {
          input.value = currentValue;
          updateBtn.style.display = "none";
        }
      });
    });

    // Handle price deletions
    deletePriceBtns.forEach((btn) => {
      btn.addEventListener("click", async (e) => {
        const row = e.target.closest("tr");
        const priceId = row.dataset.priceId;

        if (confirm("Sei sicuro di voler eliminare questo prezzo?")) {
          const result = await productPricesService.deletePrice(priceId);
          if (result.success) {
            // Refresh the modal to update the available companies list
            document.body.removeChild(modalContainer);
            this.handlePriceList(productData);
            this.showNotification("Prezzo eliminato con successo", "success");
          } else {
            this.showNotification(
              "Errore nell'eliminazione del prezzo",
              "error"
            );
          }
        }
      });
    });

    // Handle adding new price
    addPriceBtn?.addEventListener("click", async () => {
      const companySelect = modal.querySelector("#newCompanySelect");
      const priceInput = modal.querySelector("#newPriceInput");

      const companyId = companySelect.value;
      console.log("companyId", companyId);
      const price = parseFloat(priceInput.value);

      if (!companyId) {
        this.showNotification("Seleziona un'azienda", "error");
        return;
      }

      if (isNaN(price) || price < 0) {
        this.showNotification("Inserisci un prezzo valido", "error");
        return;
      }

      const result = await productPricesService.createPrice(
        productData.id,
        companyId,
        price
      );
      if (result.success) {
        // Refresh the modal to update the available companies list
        document.body.removeChild(modalContainer);
        this.handlePriceList(productData);
        this.showNotification("Prezzo aggiunto con successo", "success");
      } else {
        this.showNotification("Errore nell'aggiunta del prezzo", "error");
      }
    });

    // Handle modal close
    closeBtn.addEventListener("click", () => {
      document.body.removeChild(modalContainer);
    });
  }
}

// Create and export a singleton instance
export const productController = new ProductController();
